/* NW soevnguide: kundens svar vist paa resultatsiden. Tilfoejet 31-08-2026.

   HVORFOR: guiden viste en anbefaling uden at vise hvad den byggede paa. Kunden
   kunne hverken efterproeve den eller rette et enkelt svar uden at tage hele
   guiden om. Det er benchmarkens staerkeste enkeltgreb mod at anbefalingen
   foeles vilkaarlig, set live hos Emma Sleep, som laegger alle svar som klikbare
   chips over resultatet.

   FOLDET SAMMEN PAA MOBIL. Maalt: seks chips fylder ca. 330px lodret, og
   tilvalgene laa i forvejen naesten to skaermfulde nede paa mobil. Derfor er
   listen skjult bag en linje under 750px og altid synlig paa desktop, hvor der
   er plads. Selve loeftet, at anbefalingen bygger paa svarene, staar begge
   steder.

   TRE FAELDER I DENNE KODE:

   1. `answers`, `chosen`, `questions` og `qi` er top-level let/const og ligger
      IKKE paa window. De tilgaas som bare navne inde i try/catch. Se
      nw-sg-lager.js for samme moenster.
   2. Et klik paa en chip foerer tilbage i quizzen, og naar kunden svarer, kalder
      guiden advance(), som normalt gaar VIDERE til naeste spoergsmaal. Derfor
      overskrives advance med en returflag-version, saa man kommer direkte
      tilbage til resultatet i stedet for at skulle igennem resten igen.
   3. goToResult nulstiller lagen, pudebetraek, dyne og de smaa tilvalg. Retter
      kunden et svar der IKKE skifter materiale, ville hele det sammensatte saet
      gaa tabt. Derfor gemmes det foer og laegges tilbage bagefter, men kun hvis
      materialet er det samme. Skifter materialet, er nulstilling det rigtige. */
(function(){
  'use strict';

  var LABEL={sleepers:"Hvem",challenges:"Behov",partner:"Partner",feel:"Fornemmelse",tone:"Farvetone",about:"Om dig",size:"Størrelse"};
  var retur=false, gemt=null, gemtMat=null, aaben=false;

  function css(){
    if(document.getElementById("nw-svar-css")){ return; }
    var s=document.createElement("style");
    s.id="nw-svar-css";
    s.textContent=
      '#nwsg .nwsvar{margin-top:18px}'+
      '#nwsg .nwsvar-h{display:inline-flex;align-items:center;gap:6px;margin:0 auto 9px;padding:0;background:none;border:0;font-family:inherit;font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;color:var(--stone);cursor:default}'+
      '#nwsg .nwsvar-x{display:none;font-size:9px;transition:transform .2s}'+
      '#nwsg .nwsvar-l{display:flex;flex-wrap:wrap;gap:7px;justify-content:center}'+
      '#nwsg .nwsvar-c{cursor:pointer;border:1px solid var(--line);background:var(--creamlt);border-radius:30px;padding:6px 13px;font-family:inherit;font-size:12.5px;color:var(--ink);display:inline-flex;align-items:baseline;gap:6px;transition:.18s;text-align:left;line-height:1.3}'+
      '#nwsg .nwsvar-c:hover{border-color:var(--sage);background:#fff}'+
      '#nwsg .nwsvar-k{font-size:9.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--sageLight);flex-shrink:0}'+
      '@media(max-width:749px){'+
        '#nwsg .nwsvar-h{cursor:pointer;color:var(--sage)}'+
        '#nwsg .nwsvar-x{display:inline}'+
        '#nwsg .nwsvar.open .nwsvar-x{transform:rotate(180deg)}'+
        '#nwsg .nwsvar-l{display:none}'+
        '#nwsg .nwsvar.open .nwsvar-l{display:flex}'+
        '#nwsg .nwsvar-c{font-size:12px;padding:5px 11px}'+
      '}';
    document.head.appendChild(s);
  }

  function tekst(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

  function vaerdi(q){
    try{
      if(q.id==="challenges"){
        var muligheder=(typeof q.optionsFor==="function")?q.optionsFor(answers):(q.options||[]);
        var v=(answers.challenges||[]).map(function(id){
          var o=muligheder.filter(function(x){ return x.id===id; })[0];
          return o?o.l:null;
        }).filter(Boolean);
        return v.length?v.join(", "):null;
      }
      if(q.id==="about"){
        var g={kvinde:"Kvinde",mand:"Mand",andet:"Andet"}[answers.gender]||"";
        var d=[g, answers.age?answers.age+" år":""].filter(Boolean);
        return d.length?d.join(" · "):null;
      }
      if(q.id==="size"){
        var d2=[answers.size?answers.size+" cm":"", answers.bed?"seng "+answers.bed:"", answers.qty?answers.qty+" sæt":""].filter(Boolean);
        return d2.length?d2.join(" · "):null;
      }
      var val=answers[q.id];
      if(!val){ return null; }
      var o2=(q.options||[]).filter(function(x){ return x.id===val; })[0];
      return o2?o2.l:null;
    }catch(e){ return null; }
  }

  function byg(){
    try{
      if(typeof questions==="undefined" || typeof answers==="undefined"){ return; }
      var why=document.getElementById("rwhy");
      if(!why){ return; }
      css();
      var box=document.getElementById("nwsvar");
      if(!box){
        box=document.createElement("div");
        box.id="nwsvar";
        box.className="nwsvar";
        why.parentNode.insertBefore(box, why.nextSibling);
      }
      var synlige=questions.filter(function(q){ return !q.showIf || q.showIf(answers); });
      var dele=[];
      synlige.forEach(function(q,i){
        var v=vaerdi(q);
        if(!v){ return; }
        dele.push('<button type="button" class="nwsvar-c" data-i="'+i+'"><span class="nwsvar-k">'+tekst(LABEL[q.id]||"")+'</span>'+tekst(v)+'</button>');
      });
      if(!dele.length){ box.innerHTML=""; return; }
      box.className="nwsvar"+(aaben?" open":"");
      box.innerHTML='<button type="button" class="nwsvar-h">Det bygger vi på. Tryk for at rette.<span class="nwsvar-x">▾</span></button>'+
                    '<div class="nwsvar-l">'+dele.join("")+'</div>';

      var h=box.querySelector(".nwsvar-h");
      h.addEventListener("click", function(){ aaben=!aaben; box.classList.toggle("open", aaben); });

      Array.prototype.forEach.call(box.querySelectorAll(".nwsvar-c"), function(b){
        b.addEventListener("click", function(){
          try{
            retur=true;
            gemtMat=chosen.mat;
            try{ gemt=JSON.parse(JSON.stringify({lagen:chosen.lagen,pb:chosen.pb,pude:chosen.pude,dyne:chosen.dyne,simple:chosen.simple})); }catch(e){ gemt=null; }
            qi=parseInt(b.getAttribute("data-i"),10)||0;
            go("quiz");
            renderQ();
          }catch(e){}
        });
      });
    }catch(e){}
  }

  var aHooket=false;
  function hookAdvance(){
    if(aHooket || typeof window.advance!=="function"){ return; }
    aHooket=true;
    var orig=window.advance;
    window.advance=function(){
      if(retur){
        retur=false;
        var mat=gemtMat, g=gemt;
        goToResult();
        setTimeout(function(){
          try{
            if(g && chosen.mat===mat){
              chosen.lagen=g.lagen; chosen.pb=g.pb; chosen.pude=g.pude; chosen.dyne=g.dyne; chosen.simple=g.simple;
              if(typeof renderResult==="function"){ renderResult(); }
            }
          }catch(e){}
        }, 1200);
        return;
      }
      return orig.apply(this, arguments);
    };
  }

  var rHooket=false;
  function hookResult(){
    if(rHooket || typeof window.renderResult!=="function"){ return; }
    rHooket=true;
    var f=window.renderResult;
    window.renderResult=function(){ var r=f.apply(this, arguments); byg(); return r; };
  }

  function start(){ hookAdvance(); hookResult(); }

  start();
  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded", start); }
  window.addEventListener("load", start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();